import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId) => {
  const endpoint = URLS.home.userInsights(venueId);

  return httpClient.get(endpoint, { ignoreInternalError: true }).then(transformClientResponse);
};

export default makeEntityScaffold('SAGA.API.USER_INSIGHTS', handler, { defaultKey: 1 });
